var $ = jQuery.noConflict ();

jQuery (document).ready (function (){

    var initializeBlock = function ($block){

        let card = $ ('.form.block .card');
        let displayInfo = $ ('.form.block .display-info');
        let infoActive = displayInfo.data ('active');
        let infoDeactive = displayInfo.data ('deactive');
        let formWrapper = $ ('.form.block .form-wrapper');
        let inputFile = $ ('.file-name');
        let fileInfo = $ ('.file-info');

        card.on ('click', function (){
            let formID = $ (this).data ('id');
            card.removeClass ('active');
            $ (this).addClass ('active');

            displayInfo.text (infoDeactive).removeClass ('active');
            $ (this).find ('.display-info').addClass ('active').text (infoActive);

            formWrapper.removeClass ('active');
            $ (`.form.block .form-wrapper[data-id="${formID}"]`).addClass ('active');

            $ ('html,body').animate ({
                scrollTop: $ ('.form.block .form-wrapper.active').offset ().top - 200
            }, 'slow');


        })

        function checkFile(){
            if (fileInfo.text ().length <= 0) {
                fileInfo.addClass ('hidden');
            } else {
                fileInfo.removeClass ('hidden');
            }
        }

        fileInfo.on ('click', function (){
            $ ('.file-info').text ("");
            fileInfo.addClass ('hidden');
        });

        inputFile.change (function (){
            var filename = $ ('input[type=file]').val ().split ('\\').pop ();
            var lastIndex = filename.lastIndexOf ("\\");
            $ ('#file').val (filename);
            $ ('.file-info').text (filename);
            checkFile ();
        });

        checkFile ();

    };

    window.onload = function (){
        initializeBlock ($ (this));
    } ();


    if (window.acf) {
        window.acf.addAction ('render_block_preview/type=form', initializeBlock);
    }

});